import ExamplesCatalog from './ExamplesCatalog'
export default ExamplesCatalog
